import type { AccountDisplayMode } from '@mm/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { SettingView } from '../types/models';

/** Settings → Marketing → how advertising accounts are labelled (default BOTH). */
export function useAccountDisplayMode(): AccountDisplayMode {
  const { data } = useQuery({
    queryKey: ['settings'],
    queryFn: () => api.get<SettingView[]>('/settings'),
    staleTime: 5 * 60_000,
  });
  const value = data?.find((s) => s.key === 'marketing.accountDisplayMode')?.value;
  return value === 'ACCOUNT_ID' || value === 'ACCOUNT_NAME' ? value : 'BOTH';
}
